import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const categories = [
  { title: "Custom Boxing Gloves", image: "/Boxing/BoxingGloves/7.png", sectionId: "boxing-gloves" },
  { title: "Bag Gloves", image: "/Boxing/BoxingGloves/0.jpeg", sectionId: "bag-gloves" },
  { title: "Focus Pads", image: "/Boxing/BoxingGloves/21.jpeg", sectionId: "focus-pads" },
  { title: "Punching Bags", image: "/Boxing/BoxingGloves/28.jpg", sectionId: "punching-bags" },
  { title: "Personalized Head Guard", image: "/Boxing/BoxingGloves/15.png", sectionId: "head-guard" },
  { title: "Other Equipment", image: "/Boxing/BoxingGloves/31.png", sectionId: "other-equipment" },
  { title: "Boxing Shorts", image: "/Boxing/boxing shorts/1.jpg", sectionId: "boxing-shorts" },
  { title: "Boxing Vest", image: "/Boxing/boxing vest/1.jpg", sectionId: "boxing-vest" },
  { title: "Team Uniform", image: "/Boxing/team uniforms/1.jpg", sectionId: "team-uniform" },
  { title: "Taekwondo Uniform", image: "/Boxing/teakwondo uniforms/1.jpg", sectionId: "taekwondo-uniform" },
  { title: "Basketball Uniform", image: "/Boxing/basketball/1.jpg", sectionId: "basketball" },
];

const ImageWithLoader = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="w-full h-[220px] bg-black flex items-center justify-center overflow-hidden relative">
      {/* Skeleton */}
      {!loaded && (
        <div className="absolute inset-0 animate-pulse bg-gray-800" />
      )}

      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={`max-h-full max-w-full object-contain transition-all duration-700 hover:scale-105 ${
          loaded ? "blur-0 opacity-100" : "blur-xl opacity-0"
        }`}
      />
    </div>
  );
};

const OurProductsPage = () => {
  return (
    <section className="bg-gradient-to-b from-black via-gray-900 to-black text-white py-24 px-6 mt-[100px]">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold tracking-wide">
            Our <span className="text-red-500">Products</span>
          </h1>
          <p className="text-gray-400 mt-4 max-w-xl mx-auto">
            Premium sports gear engineered for performance and durability.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.03 }}
              className="rounded-2xl overflow-hidden bg-white/5 backdrop-blur-lg border border-white/10 shadow-lg hover:shadow-red-500/20 transition duration-300"
            >
              <Link to={`/products/${category.sectionId}`}>

                {/* Image with Blur + Skeleton */}
                <ImageWithLoader src={category.image} alt={category.title} />

                {/* Title */}
                <div className="p-4 text-center bg-gradient-to-t from-black/80 to-transparent">
                  <h2 className="text-sm md:text-base font-semibold text-white hover:text-red-400 transition">
                    {category.title}
                  </h2>
                </div>

              </Link>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurProductsPage;
